/*!
 * $script.js Async loader & dependency manager
 * https://github.com/ded/script.js
 * (c) Dustin Diaz 2013
 * License: MIT
 */

/**
 * @type {HTMLDocument}
 * @private
 */
var doc = typeof window === 'undefined' ? null : window.document;
/**
 *
 * @type {Element}
 * @private
 */
var head = doc ? doc.getElementsByTagName('head')[0] : null;
/**
 * @type {RegExp}
 * @private
 */
var validBase = /^https?:\/\//;
/**
 * @type {!Object}
 * @private
 */
var list = {};
/** @private */
var ids = {};
/**
 * @type {!Object}
 * @private
 */
var delay = {};
/**
 * @type {string}
 * @private
 */
var scriptpath = '';
/**
 * @type {!Object}
 * @private
 */
var scripts = {};
/**
 * @const
 * @type {string}
 * @private
 */
var s = 'string';
/**
 * @const
 * @type {boolean}
 * @private
 */
var f = false;
/**
 * @const
 * @type {string}
 * @private
 */
var push = 'push';
/**
 * @const
 * @type {string}
 * @private
 */
var domContentLoaded = 'DOMContentLoaded';
/**
 * @const
 * @type {string}
 * @private
 */
var readyState = 'readyState';
/**
 * @const
 * @type {string}
 * @private
 */
var addEventListenerName = 'addEventListenerName';
/**
 * @const
 * @type {string}
 * @private
 */
var onreadystatechangeName = 'onreadystatechangeName';

/**
 *
 * @param {Array.<string>|string|null} ar
 * @param {function ((string|function ((string|null)))): *|null} fn
 * @return {boolean}
 * @private
 */
function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return true;
}

/**
 * @param {Array.<string>|string|null} ar
 * @param {function((string|function((string|null))|null)): (boolean|undefined)} fn
 * @return {boolean}
 * @private
 */
function each(ar, fn) {
    every(ar, function(el) {
        return !fn(el)
    });
    return f
}

if (doc && !!!doc[readyState] && !!doc[addEventListenerName]) {
    doc[addEventListenerName](domContentLoaded, function fn() {
        doc.removeEventListener(domContentLoaded, fn, f)
        doc[readyState] = 'complete'
    }, f)
    doc[readyState] = 'loading'
}

/**
 * @param {string|Array.<string>} paths Filename or list of files to load.
 * @param {(string|function())=} idOrDone Id for filename or function to call
 *     when everything is loaded.
 * @param {function(Array.<string>)=} optDone Function to call when at least one
 *     file wasn't able to load (optional).
 */
function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && typeof idOrDone == 'function'
        , done = /** @type {function()|null} */ (idOrDoneIsDone ? idOrDone : optDone)
        , id = idOrDoneIsDone ? paths.join('') : idOrDone
        , queue = paths.length

    /**
     * @param {string|function ((string|null)): ?|string|null} item
     * @return {(boolean|undefined)}
     */
    function loopFn(item) {
        if (item['call']) {
            var itemFn = /** @type {function():(boolean|undefined)} */ (item);
            return itemFn();
        }
        return list[item];
    }

    /** @return {undefined} */
    function callback() {
        if (!--queue) {
            list[id] = 1
            if (done) {
                var doneFn = done;
                doneFn();
            }
            for (var dset in delay) {
                every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
            }
        }
    }
    setTimeout(function () {
        each(paths, function (path) {
            if (path === null) return callback()
            if (scripts[path]) {
                id && (ids[id] = 1)
                return scripts[path] == 2 && callback()
            }
            scripts[path] = 1
            id && (ids[id] = 1)
            create(/** @type {string} */ ((!validBase.test(path) && scriptpath) ? scriptpath + path + '.js' : path), callback);
        })
    }, 0)
    return $script
}

/**
 *
 * @param {string} path
 * @param {function()} fn
 * @private
 */
function create(path, fn) {
    var isLoaded = false;
    // http://stackoverflow.com/a/15437678/511292
    /**
     * @param {HTMLScriptElement} scriptElement
     * @param {function()} callback
     */
    var ieLoadBugFix = function(scriptElement, callback) {
        if (isLoaded) {
            return;
        }
        if (scriptElement.readyState === 'loaded' || scriptElement.readyState === 'completed') {
            callback();
        }else {
            setTimeout(function() {ieLoadBugFix(scriptElement, callback); }, 100);
        }
    };

    var el = /** @type {HTMLScriptElement} */ (doc.createElement('script'))
        , loaded = f;
    /** @type {function()} */
    var onload = el.onload = el.onerror = el[onreadystatechangeName] = function () {
        if (isLoaded) {
            return;
        }
        isLoaded = true;
        if (!!/** @type {string} */ (el['readyState']) && !/^c|loade/.test(/** @type {string} */ (el['readyState']))) {
            return;
        }
        el.onload = el[onreadystatechangeName] = null
        loaded = 1
        scripts[path] = 2
        fn()
    }
    ieLoadBugFix(el, onload);
    el.async = 1
    el.src = path
    head.insertBefore(el, head.firstChild)
}

$script.get = create

/**
 *
 * @param {Array.<string>} scripts
 * @param {(string|function())=} id
 * @param {function()=} done
 * @private
 */
$script.order = function (scripts, id, done) {
    (function callback() {
        var s = scripts.shift()
        if (!scripts.length) $script(s, id, done)
        else $script(s, callback)
    }())
}

/**
 * @param {string} p
 */
$script.path = function (p) {
    scriptpath = p
}

/**
 * @param {string|Array.<string>} deps
 * @param {function()} ready
 * @param {function(Array.<string>)=} req
 */
$script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    var isLoaded = !each(deps,  function (dep) {
        if (!list[dep]) {
            missing.push(dep);
        }
    }) && every(deps, function (dep) {return list[dep]});

    if (isLoaded) {
        ready();
    } else {
        (function (key) {
            if (!delay[key]) {
                delay[key] = [];
            }
            delay[key][push](ready)
            if (req) {
                var reqFn = req;
                reqFn(missing);
            }
        }(deps.join('|')))
    }
    return $script
}

/** @param {(string|function())=} idOrDone */
$script.done = function (idOrDone) {
    $script([null], idOrDone)
}


module.exports = $script;
